// frontend/src/index.js
import React from 'react'
import ReactDOM from 'react-dom/client' // Utilisation de React 18+
import { Provider } from 'react-redux'
import App from './App'
import store from './store/store' // Assurez-vous que le chemin est correct
import './i18n' // Init i18next AVANT le render (langue résolue depuis localStorage → pas de flash)
import './utils/pwaInstall' // Capture `beforeinstallprompt` au plus tôt (avant le mount React)
import './scss/style.scss'
import './scss/examples.scss'
import { initSentry, ErrorBoundary } from './utils/sentry'

// Init Sentry AVANT le render React : sinon les erreurs lors du premier
// mount ne sont pas capturées. No-op silencieux en dev / sans DSN.
initSentry()

// Fallback UI minimaliste : on évite un écran blanc total + bouton de reload.
// Sentry capture l'exception en arrière-plan.
const FallbackUI = ({ error, resetError }) => (
  <div style={{ padding: '2rem', maxWidth: 540, margin: '4rem auto', fontFamily: 'system-ui, sans-serif' }}>
    <h2 style={{ marginBottom: '1rem' }}>Une erreur inattendue est survenue</h2>
    <p style={{ color: '#475569', marginBottom: '1rem' }}>
      L'équipe Terrilink a été notifiée. Vous pouvez recharger la page pour reprendre.
    </p>
    {import.meta.env.DEV && error && (
      <pre style={{ background: '#f1f5f9', padding: '1rem', borderRadius: 6, overflow: 'auto', fontSize: 12 }}>
        {error.toString()}
      </pre>
    )}
    <button
      onClick={() => { resetError?.(); window.location.reload() }}
      style={{ marginTop: '1rem', padding: '0.6rem 1.2rem', background: '#3481d2', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}
    >
      Recharger la page
    </button>
  </div>
)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={FallbackUI} showDialog={false}>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
)
